import { mdiChevronDown } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const ChevronDown = (props: IconProps) => (
    <Icon
        data-testid="IconButton__ChevronDown"
        path={mdiChevronDown}
        size={1}
        {...props}
    />
)

export default ChevronDown
